(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function initializeCart(section) {
      if (!section || section.dataset.cartReady === 'true') return;
      section.dataset.cartReady = 'true';

      const form = section.querySelector('.h-cart__form');
      const sectionId = section.dataset.sectionId;
      const changeUrl = section.dataset.cartChangeUrl;
      let updateTimer;

      function fallbackToRegularUpdate() {
        if (!form) return;
        const updateButton = form.querySelector('button[name="update"]');
        if (form.requestSubmit) {
          form.requestSubmit(updateButton || undefined);
        } else {
          form.submit();
        }
      }

      function updateCart(item, input) {
        if (!form || !sectionId || !changeUrl || section.classList.contains('is-updating')) return;

        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(function () {
          const lineKey = item.dataset.lineKey;
          const quantity = Math.max(0, Number(input.value || 0));
          const note = form.querySelector('textarea[name="note"]');
          const savedNote = note ? note.value : '';

          if (!lineKey) {
            fallbackToRegularUpdate();
            return;
          }

          section.classList.add('is-updating');

          fetch(changeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: quantity,
              sections: [sectionId],
              sections_url: window.location.pathname
            })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart update failed');
              return response.json();
            })
            .then(function (cartData) {
              const sectionHtml = cartData.sections && cartData.sections[sectionId];
              if (!sectionHtml) throw new Error('Cart section rendering failed');

              const documentFragment = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const newSection = documentFragment.querySelector('[data-cart-section]');
              if (!newSection) throw new Error('Updated cart section missing');

              const newNote = newSection.querySelector('textarea[name="note"]');
              if (newNote) newNote.value = savedNote;

              section.replaceWith(newSection);
              initializeCart(newSection);

              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: cartData }
              }));
            })
            .catch(function (error) {
              console.error(error);
              section.classList.remove('is-updating');
              fallbackToRegularUpdate();
            });
        }, 180);
      }

      section.querySelectorAll('[data-cart-item]').forEach(function (item) {
        const input = item.querySelector('[data-cart-quantity]');
        const minus = item.querySelector('[data-cart-minus]');
        const plus = item.querySelector('[data-cart-plus]');
        if (!input) return;

        if (minus) minus.addEventListener('click', function () {
          input.value = Math.max(0, Number(input.value || 0) - 1);
          updateCart(item, input);
        });

        if (plus) plus.addEventListener('click', function () {
          input.value = Math.max(0, Number(input.value || 0) + 1);
          updateCart(item, input);
        });

        input.addEventListener('change', function () {
          updateCart(item, input);
        });
      });
    }

    document.querySelectorAll('[data-cart-section]').forEach(initializeCart);
    document.addEventListener('shopify:section:load', function (event) {
      initializeCart(event.target.querySelector('[data-cart-section]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initializeCollection(section) {
      if (!section || section.dataset.hcReady === 'true') return;
      section.dataset.hcReady = 'true';

      const panel = section.querySelector('[data-hc-filter-panel]');
      const overlay = section.querySelector('.h-collection__filter-overlay');
      const openButton = section.querySelector('[data-hc-filter-open]');
      const sortSelect = section.querySelector('[data-hc-sort]');

      function setFilters(open) {
        if (!panel || !overlay || !openButton) return;
        panel.classList.toggle('is-open', open);
        overlay.classList.toggle('is-open', open);
        openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('hc-filter-open', open);
      }

      if (openButton) {
        openButton.addEventListener('click', function () {
          setFilters(true);
        });
      }

      section.querySelectorAll('[data-hc-filter-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          setFilters(false);
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortSelect.form.submit();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setFilters(false);
      });
    }

    document.querySelectorAll('.h-collection').forEach(initializeCollection);

    document.addEventListener('shopify:section:load', function (event) {
      initializeCollection(event.target.querySelector('.h-collection'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeCollections(section) {
      if (!section || section.dataset.hclReady === 'true') return;
      section.dataset.hclReady = 'true';

      const search = section.querySelector('[data-hcl-search]');
      const cards = Array.from(section.querySelectorAll('[data-hcl-card]'));
      const empty = section.querySelector('[data-hcl-empty]');

      if (!search || !cards.length) return;

      search.addEventListener('input', function () {
        const query = search.value.trim().toLowerCase();
        let visible = 0;

        cards.forEach(function (card) {
          const matches = !query || card.dataset.hclTitle.includes(query);
          card.hidden = !matches;
          if (matches) visible += 1;
        });

        if (empty) empty.hidden = visible !== 0;
      });
    }

    document.querySelectorAll('.h-collections').forEach(initializeCollections);

    document.addEventListener('shopify:section:load', function (event) {
      initializeCollections(event.target.querySelector('.h-collections'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

document.addEventListener('click', function (event) {
document
.querySelectorAll('.hassamal-category-menu[open]')
.forEach(function (menu) {
if (!menu.contains(event.target)) {
menu.removeAttribute('open');
}
});
});

document.addEventListener('toggle', function (event) {
const openedSubmenu = event.target;

if (
!openedSubmenu.matches('.hassamal-mobile-categories .hassamal-mobile-submenu') ||
!openedSubmenu.open
) return;

const categorySection = openedSubmenu.closest('.hassamal-mobile-categories');

if (!categorySection) return;

categorySection
.querySelectorAll('.hassamal-mobile-submenu[open]')
.forEach(function (submenu) {
if (submenu !== openedSubmenu) {
submenu.removeAttribute('open');
}
});
}, true);

document.addEventListener('click', function (event) {
const closeButton = event.target.closest('[data-hassamal-close-drawer]');

if (!closeButton) return;

const drawer = closeButton.closest('.hassamal-mobile-drawer');

if (drawer) {
drawer.removeAttribute('open');

drawer
.querySelectorAll('.hassamal-mobile-categories[open], .hassamal-mobile-submenu[open]')
.forEach(function (details) {
details.removeAttribute('open');
});
}
});

document.addEventListener('keydown', function (event) {
if (event.key !== 'Escape') return;

document
.querySelectorAll('.hassamal-mobile-drawer[open]')
.forEach(function (drawer) {
drawer.removeAttribute('open');

drawer
.querySelectorAll('.hassamal-mobile-categories[open], .hassamal-mobile-submenu[open]')
.forEach(function (details) {
details.removeAttribute('open');
});
});

document
.querySelectorAll('.hassamal-category-menu[open]')
.forEach(function (menu) {
menu.removeAttribute('open');
});
});

function updateHassamalHomeHeader() {
document
.querySelectorAll('.hassamal-header-shell--home')
.forEach(function (header) {
header.classList.toggle(
'hassamal-header-shell--scrolled',
window.scrollY > 20
);
});
}

updateHassamalHomeHeader();

window.addEventListener('scroll', updateHassamalHomeHeader, {
passive: true
});

/* Predictive search — products only, desktop and mobile */
function initializeHassamalPredictiveSearch(form) {
if (!form || form.dataset.predictiveReady === 'true') return;
form.dataset.predictiveReady = 'true';

const input = form.querySelector('[data-hassamal-predictive-input]');
const resultsBox = form.querySelector('[data-hassamal-predictive-results]');
const endpoint = form.dataset.hassamalPredictiveUrl;
const currency = form.dataset.hassamalCurrency || 'MUR';
let timer;
let controller;
let activeIndex = -1;
if (!input || !resultsBox || !endpoint) return;

function formatProductPrice(value) {
const amount = Number(value);
if (!Number.isFinite(amount)) return '';
try {
return new Intl.NumberFormat(document.documentElement.lang || 'en', {
style: 'currency',
currency: currency,
currencyDisplay: 'narrowSymbol'
}).format(amount);
} catch (error) {
return currency + ' ' + amount.toFixed(2);
}
}

function closeResults() {
resultsBox.hidden = true;
resultsBox.innerHTML = '';
input.setAttribute('aria-expanded', 'false');
activeIndex = -1;
}

function renderProducts(data, query) {
const products = data && data.resources && data.resources.results && data.resources.results.products
? data.resources.results.products
: [];
if (!products.length) { closeResults(); return; }

resultsBox.innerHTML = '';
const heading = document.createElement('div');
heading.className = 'hassamal-predictive__heading';
heading.textContent = 'Suggested products';
resultsBox.appendChild(heading);
const list = document.createElement('ul');
list.className = 'hassamal-predictive__list';

products.slice(0, 6).forEach(function (product) {
const item = document.createElement('li');
item.setAttribute('role', 'option');
const link = document.createElement('a');
link.className = 'hassamal-predictive__link';
link.href = product.url;
const media = document.createElement('span');
media.className = 'hassamal-predictive__image';
const featuredImage = product.featured_image;
const imageUrl = featuredImage && (featuredImage.url || featuredImage.src);

if (imageUrl) {
const image = document.createElement('img');
image.src = imageUrl;
image.alt = product.title || '';
image.width = 48;
image.height = 48;
image.loading = 'lazy';
media.appendChild(image);
} else {
media.textContent = 'H';
}

const text = document.createElement('span');
text.className = 'hassamal-predictive__text';
const title = document.createElement('strong');
title.textContent = product.title || '';
text.appendChild(title);
const formattedPrice = formatProductPrice(product.price);
if (formattedPrice) {
const price = document.createElement('span');
price.className = 'hassamal-predictive__price';
price.textContent = formattedPrice;
text.appendChild(price);
}
const arrow = document.createElement('span');
arrow.className = 'hassamal-predictive__arrow';
arrow.textContent = '→';
link.appendChild(media);
link.appendChild(text);
link.appendChild(arrow);
item.appendChild(link);
list.appendChild(item);
});

resultsBox.appendChild(list);
const viewAll = document.createElement('a');
viewAll.className = 'hassamal-predictive__all';
viewAll.href = form.action + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
viewAll.textContent = 'View all results for “' + query + '” →';
resultsBox.appendChild(viewAll);
resultsBox.hidden = false;
input.setAttribute('aria-expanded', 'true');
activeIndex = -1;
}

function fetchSuggestions(query) {
if (controller) controller.abort();
controller = new AbortController();
resultsBox.innerHTML = '<div class="hassamal-predictive__loading">Searching…</div>';
resultsBox.hidden = false;
input.setAttribute('aria-expanded', 'true');
const url = new URL(endpoint, window.location.origin);
url.searchParams.set('q', query);
url.searchParams.set('resources[type]', 'product');
url.searchParams.set('resources[limit]', '6');
url.searchParams.set('resources[options][unavailable_products]', 'last');

fetch(url.toString(), {
credentials: 'same-origin',
headers: { 'Accept': 'application/json' },
signal: controller.signal
})
.then(function (response) {
if (!response.ok) throw new Error('Predictive search failed');
return response.json();
})
.then(function (data) { renderProducts(data, query); })
.catch(function (error) { if (error.name !== 'AbortError') closeResults(); });
}

input.addEventListener('input', function () {
const query = input.value.trim();
window.clearTimeout(timer);
if (query.length < 2) {
if (controller) controller.abort();
closeResults();
return;
}
timer = window.setTimeout(function () { fetchSuggestions(query); }, 220);
});

form.addEventListener('keydown', function (event) {
const links = Array.from(resultsBox.querySelectorAll('.hassamal-predictive__link'));
if (event.key === 'Escape') { closeResults(); input.focus(); return; }
if (!links.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
event.preventDefault();
links.forEach(function (link) { link.classList.remove('is-active'); });
activeIndex = event.key === 'ArrowDown'
? (activeIndex + 1) % links.length
: (activeIndex - 1 + links.length) % links.length;
links[activeIndex].classList.add('is-active');
links[activeIndex].focus();
});

document.addEventListener('click', function (event) {
if (!form.contains(event.target)) closeResults();
});
}

document.querySelectorAll('[data-hassamal-predictive-form]').forEach(initializeHassamalPredictiveSearch);
document.addEventListener('shopify:section:load', function (event) {
event.target.querySelectorAll('[data-hassamal-predictive-form]').forEach(initializeHassamalPredictiveSearch);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
    (function () {
      function initializeProduct(section) {
        if (!section || section.dataset.productReady === 'true') return;
        section.dataset.productReady = 'true';

        const mediaItems = Array.from(section.querySelectorAll('[data-product-media]'));
        const thumbnails = Array.from(section.querySelectorAll('[data-product-thumbnail]'));
        const previous = section.querySelector('[data-product-previous]');
        const next = section.querySelector('[data-product-next]');
        const indexLabel = section.querySelector('[data-product-current-index]');
        const variantSelect = section.querySelector('[data-product-variant]');
        const optionGroups = Array.from(section.querySelectorAll('[data-product-option-group]'));
        const choiceButtons = Array.from(section.querySelectorAll('[data-product-choice]'));
        const price = section.querySelector('[data-product-price]');
        const compare = section.querySelector('[data-product-compare]');
        const saleBadge = section.querySelector('[data-product-sale]');
        const soldBadge = section.querySelector('[data-product-sold]');
        const status = section.querySelector('[data-product-status]');
        const skuWrap = section.querySelector('.h-product__sku');
        const sku = section.querySelector('[data-product-sku]');
        const addButton = section.querySelector('[data-product-add]');
        const addLabel = section.querySelector('[data-product-add-label]');

        function showMedia(mediaId) {
          if (!mediaItems.length) return;
          let activeIndex = mediaItems.findIndex(function (item) {
            return String(item.dataset.productMedia) === String(mediaId);
          });
          if (activeIndex < 0) activeIndex = 0;

          mediaItems.forEach(function (item, index) {
            const active = index === activeIndex;
            item.hidden = !active;
            item.classList.toggle('is-active', active);
            if (!active) {
              item.querySelectorAll('video').forEach(function (video) { video.pause(); });
            }
          });

          thumbnails.forEach(function (thumb, index) {
            const active = index === activeIndex;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-current', active ? 'true' : 'false');
          });

          if (indexLabel) indexLabel.textContent = String(activeIndex + 1);
        }

        thumbnails.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            showMedia(thumb.dataset.productThumbnail);
          });
        });

        function moveMedia(direction) {
          if (!mediaItems.length) return;
          let index = mediaItems.findIndex(function (item) { return !item.hidden; });
          index = (index + direction + mediaItems.length) % mediaItems.length;
          showMedia(mediaItems[index].dataset.productMedia);
        }

        if (previous) previous.addEventListener('click', function () { moveMedia(-1); });
        if (next) next.addEventListener('click', function () { moveMedia(1); });

        function getVariantOptions(option) {
          try {
            return JSON.parse(option.dataset.options || '[]');
          } catch (error) {
            return [];
          }
        }

        function syncChoiceButtons(option) {
          if (!option) return;
          const selectedValues = getVariantOptions(option);

          choiceButtons.forEach(function (button) {
            const optionIndex = Number(button.dataset.optionIndex);
            const selected = selectedValues[optionIndex] === button.dataset.optionValue;
            const availableSomewhere = Array.from(variantSelect.options).some(function (variantOption) {
              const values = getVariantOptions(variantOption);
              return values[optionIndex] === button.dataset.optionValue && variantOption.dataset.available === 'true';
            });

            button.classList.toggle('is-selected', selected);
            button.classList.toggle('is-unavailable', !availableSomewhere);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        }

        choiceButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            const group = button.closest('[data-product-option-group]');
            if (!group || !variantSelect) return;

            group.querySelectorAll('[data-product-choice]').forEach(function (groupButton) {
              const selected = groupButton === button;
              groupButton.classList.toggle('is-selected', selected);
              groupButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });

            const selectedValues = optionGroups.map(function (optionGroup) {
              const selectedButton = optionGroup.querySelector('[data-product-choice].is-selected');
              return selectedButton ? selectedButton.dataset.optionValue : '';
            });

            const matchingOption = Array.from(variantSelect.options).find(function (variantOption) {
              const values = getVariantOptions(variantOption);
              return values.length === selectedValues.length && values.every(function (value, index) {
                return value === selectedValues[index];
              });
            });

            if (matchingOption) {
              variantSelect.value = matchingOption.value;
              variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        if (variantSelect) {
          variantSelect.addEventListener('change', function () {
            const option = variantSelect.options[variantSelect.selectedIndex];
            const available = option.dataset.available === 'true';
            const mediaId = option.dataset.mediaId;

            if (price) price.textContent = option.dataset.price;
            if (compare) {
              compare.textContent = option.dataset.compare || '';
              compare.classList.toggle('is-hidden', !option.dataset.compare);
            }
            if (saleBadge) saleBadge.classList.toggle('is-hidden', !option.dataset.compare || !available);
            if (soldBadge) soldBadge.classList.toggle('is-hidden', available);
            if (status) {
              status.textContent = available ? 'In stock' : 'Sold out';
              status.classList.toggle('is-sold', !available);
            }
            if (sku && skuWrap) {
              sku.textContent = option.dataset.sku || '';
              skuWrap.classList.toggle('is-hidden', !option.dataset.sku);
            }
            if (addButton && addLabel) {
              addButton.disabled = !available;
              addLabel.textContent = available ? 'Add to cart' : 'Sold out';
            }
            if (mediaId) showMedia(mediaId);

            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url.toString());

            syncChoiceButtons(option);
          });

          syncChoiceButtons(variantSelect.options[variantSelect.selectedIndex]);
        }

      }

      document.querySelectorAll('[data-product-section]').forEach(initializeProduct);

      document.addEventListener('shopify:section:load', function (event) {
        initializeProduct(event.target.querySelector('[data-product-section]'));
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
    (function () {
      function initializePredictiveSearch(form) {
        if (!form || form.dataset.predictiveReady === 'true') return;
        form.dataset.predictiveReady = 'true';

        const input = form.querySelector('[data-predictive-input]');
        const resultsBox = form.querySelector('[data-predictive-results]');
        const endpoint = form.dataset.predictiveUrl;
        let debounceTimer;
        let requestController;
        let activeIndex = -1;

        if (!input || !resultsBox || !endpoint) return;

        function closeResults() {
          resultsBox.hidden = true;
          resultsBox.innerHTML = '';
          input.setAttribute('aria-expanded', 'false');
          activeIndex = -1;
        }

        function createMedia(resource, type) {
          const media = document.createElement('span');
          media.className = 'h-search-predictive__media';
          const image = resource.featured_image || resource.image;
          const imageUrl = image && (image.url || image.src);

          if (imageUrl) {
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = resource.title || '';
            img.width = 50;
            img.height = 50;
            img.loading = 'lazy';
            media.appendChild(img);
          } else {
            media.textContent = type.charAt(0).toUpperCase();
          }

          return media;
        }

        function createResult(resource, type) {
          const item = document.createElement('li');
          item.className = 'h-search-predictive__item';
          item.setAttribute('role', 'option');

          const link = document.createElement('a');
          link.className = 'h-search-predictive__link';
          link.href = resource.url;
          link.appendChild(createMedia(resource, type));

          const text = document.createElement('span');
          text.className = 'h-search-predictive__text';
          const title = document.createElement('strong');
          title.textContent = resource.title;
          const label = document.createElement('span');
          label.textContent = type;
          text.appendChild(title);
          text.appendChild(label);
          link.appendChild(text);

          const arrow = document.createElement('span');
          arrow.className = 'h-search-predictive__arrow';
          arrow.textContent = '→';
          link.appendChild(arrow);
          item.appendChild(link);
          return item;
        }

        function renderResults(data, query) {
          const resources = data && data.resources && data.resources.results;
          if (!resources) {
            closeResults();
            return;
          }

          const orderedTypes = ['products', 'collections', 'articles', 'pages'];
          const matches = [];
          orderedTypes.forEach(function (type) {
            (resources[type] || []).forEach(function (resource) {
              if (matches.length < 8) matches.push({ resource: resource, type: type.slice(0, -1) });
            });
          });

          if (!matches.length) {
            closeResults();
            return;
          }

          resultsBox.innerHTML = '';

          const head = document.createElement('div');
          head.className = 'h-search-predictive__head';
          const headText = document.createElement('span');
          headText.textContent = 'Suggested results';
          const close = document.createElement('button');
          close.className = 'h-search-predictive__close';
          close.type = 'button';
          close.setAttribute('aria-label', 'Close suggestions');
          close.textContent = '×';
          close.addEventListener('click', closeResults);
          head.appendChild(headText);
          head.appendChild(close);

          const list = document.createElement('ul');
          list.className = 'h-search-predictive__list';
          matches.forEach(function (match) {
            list.appendChild(createResult(match.resource, match.type));
          });

          const allResults = document.createElement('a');
          allResults.className = 'h-search-predictive__all';
          allResults.href = form.action + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
          allResults.textContent = 'View all results for “' + query + '” →';

          resultsBox.appendChild(head);
          resultsBox.appendChild(list);
          resultsBox.appendChild(allResults);
          resultsBox.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          activeIndex = -1;
        }

        function requestSuggestions(query) {
          if (requestController) requestController.abort();
          requestController = new AbortController();

          resultsBox.innerHTML = '<div class="h-search-predictive__loading">Searching…</div>';
          resultsBox.hidden = false;
          input.setAttribute('aria-expanded', 'true');

          const url = new URL(endpoint, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product,collection,article,page');
          url.searchParams.set('resources[limit]', '8');
          url.searchParams.set('resources[limit_scope]', 'all');
          url.searchParams.set('resources[options][unavailable_products]', 'last');

          fetch(url.toString(), {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
            signal: requestController.signal
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Predictive search failed');
              return response.json();
            })
            .then(function (data) { renderResults(data, query); })
            .catch(function (error) {
              if (error.name !== 'AbortError') closeResults();
            });
        }

        input.addEventListener('input', function () {
          const query = input.value.trim();
          window.clearTimeout(debounceTimer);
          if (query.length < 2) {
            if (requestController) requestController.abort();
            closeResults();
            return;
          }
          debounceTimer = window.setTimeout(function () { requestSuggestions(query); }, 220);
        });

        form.addEventListener('keydown', function (event) {
          const links = Array.from(resultsBox.querySelectorAll('.h-search-predictive__link'));
          if (event.key === 'Escape') {
            closeResults();
            return;
          }
          if (!links.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;

          event.preventDefault();
          links.forEach(function (link) { link.classList.remove('is-active'); });
          activeIndex = event.key === 'ArrowDown'
            ? (activeIndex + 1) % links.length
            : (activeIndex - 1 + links.length) % links.length;
          links[activeIndex].classList.add('is-active');
          links[activeIndex].focus();
        });

        document.addEventListener('click', function (event) {
          if (!form.contains(event.target)) closeResults();
        });
      }

      document.querySelectorAll('[data-predictive-form]').forEach(initializePredictiveSearch);
      document.addEventListener('shopify:section:load', function (event) {
        initializePredictiveSearch(event.target.querySelector('[data-predictive-form]'));
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
